import Dashboard from "../pages/Dashboard/Dashboard";
import Settings from "../pages/Settings/Settings";
import AllLead from "../pages/AllLeads/index";
import OlaLeads from "../pages/OlaLeads/index";
import AmpereLeads from "../pages/AmpereLeads/index";
import SimpleLeads from "../pages/SimpleLeads/index";
import BrandCombination from "../pages/BrandCombination/index";
import TPLeads from "../pages/TPLeads/index";
import RevoltLeads from "../pages/RevoltLeads/Index";
import Tvsleads from "../pages/TvsLeads/Index";
import LeadVerification from "../pages/LeadVerification/Index";
import DialShreeLeads from "../pages/DialshreeLeads/Index";
import DialShreeInboundCallLeads from "../pages/DialshreeInboundCallLeads/Index";
import GenerateReport from "../pages/GenerateReport/GenerateReport";
import Campaigns from "../pages/Campaigns/Campaigns";
import LeadPacing from "../pages/LeadPacing/LeadPacing";
import Notifications from "../pages/Notifications/index";

const routes = [
  {
    path: "/dashboard",
    exact: true,
    name: "Dashboard",
    component: Dashboard,
    key: "DASHBOARD",
  },
  {
    path: "/settings",
    exact: true,
    name: "Settings",
    component: Settings,
    key: "PROTECTED",
  },

  {
    path: "/leads/all",
    exact: true,
    name: "All Leads Listing",
    component: AllLead,
    key: "ALL_LEADS",
  },
  {
    path: "/revolt-leads",
    exact: true,
    name: "Revolt Leads",
    component: RevoltLeads,
    key: "OLALEADS",
  },
  {
    path: "/ola-leads",
    exact: true,
    name: "Ola Leads Listing",
    component: OlaLeads,
    key: "OLALEADS",
  },
  {
    path: "/ampere-leads",
    exact: true,
    name: "Ampere Leads Listing",
    component: AmpereLeads,
    key: "OLALEADS",
  },
  {
    path: "/simple-leads",
    exact: true,
    name: "Simple Leads Listing",
    component: SimpleLeads,
    key: "SIMPLE_LEADS",
  },
  {
    path: "/tp-leads",
    exact: true,
    name: "TP Leads",
    component: TPLeads,
    key: "TP_LEADS",
  },
  {
    path: "/brand-combination",
    exact: true,
    name: "Brand Combination",
    component: BrandCombination,
    key: "BRANDCOMBINATION",
  },
  {
    path: "/tvs-leads",
    exact: true,
    name: "Tvs Leads",
    component: Tvsleads,
    key: "TVS_LEADS",
  },
  {
    path: "/lead-verification",
    exact: true,
    name: "Lead Verification",
    component: LeadVerification,
    key: "OLALEADS",
  },
  {
    path: "/dialshree-leads",
    exact: true,
    name: "DialShree Leads",
    component: DialShreeLeads,
    key: "DIALSHREE",
  },
  {
    path: "/dialshree-inbound-call-leads",
    exact: true,
    name: "DialShree Inbound Call Leads",
    component: DialShreeInboundCallLeads,
    key: "DIALSHREE",
  },
  {
    path: "/generate-report",
    exact: true,
    name: "Generate Report",
    component: GenerateReport,
    key: "GENERATE_REPORT",
  },
  {
    path: "/campaigns",
    exact: true,
    name: "Campaigns",
    component: Campaigns,
    key: "CAMPAIGNS",
  },
  {
    path: "/lead-pacing",
    exact: true,
    name: "Lead Pacing",
    component: LeadPacing,
    key: "LEAD_PACING",
  },
  {
    path: "/notifications",
    exact: true,
    name: "Notifications",
    component: Notifications,
    key: "NOTIFICATIONS",
  },
];

export default routes;
